export default __webpack_public_path__ + "img/jpg/head-mobile.jpg";